/* consult-dialog.js
 * Wires up the "Tell us about your dog" modal. Lovable parity:
 * src/pages/About.tsx <Dialog> open/close behavior.
 *
 * Open: any element with data-dialog-trigger="consult"
 * Close: [data-consult-close], ESC (native), backdrop click
 * Auto-reopen: if the form posted back successfully or with errors, the
 *   server-rendered DOM contains [data-consult-success] or
 *   [data-consult-errors] — reopen the dialog so the user sees the result
 *   inside the modal instead of just at the top of the page.
 */
(function () {
  'use strict';

  const dialog = document.querySelector('[data-consult-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  function open() {
    if (!dialog.open) dialog.showModal();
  }
  function close() {
    if (dialog.open) dialog.close();
  }

  // Trigger: any element with [data-dialog-trigger="consult"]
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-dialog-trigger="consult"]');
    if (trigger) {
      e.preventDefault();
      open();
      return;
    }
    const closer = e.target.closest('[data-consult-close]');
    if (closer && dialog.contains(closer)) {
      e.preventDefault();
      close();
      return;
    }
    // Click on backdrop (the dialog element itself, outside the panel)
    if (e.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      const inDialog = e.clientX >= rect.left && e.clientX <= rect.right
                    && e.clientY >= rect.top  && e.clientY <= rect.bottom;
      if (!inDialog) close();
    }
  });

  // Auto-reopen on form post-back
  const hasSuccess = dialog.querySelector('[data-consult-success]');
  const hasErrors  = dialog.querySelector('[data-consult-errors]');
  if (hasSuccess || hasErrors) {
    // Wait a tick so the page paints first, then surface the result.
    window.requestAnimationFrame(function () {
      open();
      // Move focus into the dialog for accessibility.
      const focusTarget = hasErrors
        ? dialog.querySelector('input, textarea')
        : dialog.querySelector('[data-consult-close]');
      if (focusTarget) focusTarget.focus();
    });
  }
})();
